import Vue from 'vue';
export class FAQVueComponent extends Vue {
    constructor() {
        super(...arguments);
        this.getBoundData = () => {
            return {
                model: {
                    visibleQuestions: ['Q1']
                }
            };
        };
    }
    isVisible(questionId) {
        const vm = this;
        if (vm.model.visibleQuestions.indexOf(questionId) === -1) {
            return false;
        }
        return true;
    }
    ;
    plusMinusClass(questionId) {
        const vm = this;
        const plusOrMinusClass = vm.model.visibleQuestions.indexOf(questionId) === -1
            ? 'fa fa-plus'
            : 'fa fa-minus';
        return plusOrMinusClass;
    }
    toggleShowHide(questionId) {
        const vm = this;
        if (vm.model.visibleQuestions.indexOf(questionId) === -1) {
            vm.model.visibleQuestions.push(questionId);
        }
        else {
            vm.model.visibleQuestions.splice(vm.model.visibleQuestions.indexOf(questionId), 1);
        }
    }
    ;
    getBoundMethods() {
        return {
            toggleShowHide: this.toggleShowHide,
            isVisible: this.isVisible,
            plusMinusClass: this.plusMinusClass
        };
    }
}
const faqVueComponent = new FAQVueComponent();
new Vue({
    el: "#app",
    data: faqVueComponent.getBoundData,
    methods: faqVueComponent.getBoundMethods()
});
